import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import CaptableManagementChart from '../components/CaptableManagementChart'
import CaptableManagementList from '../components/CaptableManagementList'
import CaptableManagementQuickActions from '../components/CaptableManagementQuickActions'
import CaptableManagementMap from '../components/CaptableManagementMap'
import CaptableManagementGraph from '../components/CaptableManagementGraph'
import CaptableManagementRound from '../components/CaptableManagementRound'
import {InfoCard2} from '../../widgets/components/UI/InfoCard2'
import {PageTitle} from '../../../../_metronic/layout/core'
import {CaptableManagementBreadCrumbs} from '../core/_constants'
import CaptableManagementCard from '../components/CaptableManagementCard'
import {useAuth} from '../../auth'
import {getShareholderOverview} from '../core/_requests'
import {toast} from 'react-toastify'
import {getShareholdersDashboardCounts} from '../../stakeholders/stakeholders-and-investors/core/_requests'
import brandingConfig from '../../../../config/brandingConfig'
import CaptableManagementCardSkeleton from '../components/CaptableManagementCardSkeleton'
import CaptableManagementChartSkeleton from '../components/CaptableManagementChartSkeleton'
import CaptableManagementListSkeleton from '../components/CaptableManagementListSkeleton'
import CaptableManagementMapSkeleton from '../components/CaptableManagementMapSkeleton'
import CaptableManagementGraphSkeleton from '../components/CaptableManagementGraphSkeleton'
import CaptableManagementRoundSkeleton from '../components/CaptableManagementRoundSkeleton'
import CaptableManagementQuickActionsSkeleton from '../components/CaptableManagementQuickActionsSkeleton'

const Overview = () => {
  const {companyId} = useAuth()
  const {formatMessage} = useIntl()
  const [overviewData, setOverviewData] = useState<any>()
  const [investors, setInvestors] = useState<any[]>()
  const [promoters, setPromoters] = useState<any[]>()
  const [ownership, setOwnership] = useState<any[]>()
  const [shareClass, setShareClass] = useState<any[]>()
  const [dashboardLoading, setDashboardLoading] = useState(false)
  const [countryCounts, setCountryCounts] = useState({
    countriesCount: {
      indianCountryCount: 0,
      otherCountriesCount: [
        {
          countryId: 0,
          countryName: '',
        },
      ],
      totalOtherCountriesCount: 0,
      totalCountriesCount: 0,
    },
  }) // eslint-disable-next-line

  const shares_usage = [
    {name: 'Issued', value: 90.998},
    {name: 'Not Issued', value: 10},
  ]
  const diluted_ownership = [
    {name: 'Series A Investors', value: 46.998},
    {name: 'Founders', value: 32.998},
    {name: 'Seed II Investors', value: 10.998},
  ]

  const colors = ['#0D216D', '#1D3EB9', '#4776E6']

  const getOverview = async () => {
    setDashboardLoading(true)
    try {
      if (companyId) {
        const {
          data: {success, data, errors},
        }: any = await getShareholderOverview(companyId)
        if (success) {
          setOverviewData(data)
          const transformedInvestors = data.topShareInvestors?.map((shareholder: any) => ({
            name: shareholder.legalName || `${shareholder.firstName} ${shareholder.lastName}`,
            value: shareholder.percentage,
          }))
          setInvestors(transformedInvestors)
          if (data.topSharePromoters.length > 0) {
            const transformedPromoters = data.topSharePromoters.map((shareholder: any) => ({
              name: shareholder.legalName || `${shareholder.firstName} ${shareholder.lastName}`,
              value: shareholder.percentage,
            }))
            setPromoters(transformedPromoters)
          }
          if (data.totalOwnership.length > 0) {
            const transformedOwnership = data.totalOwnership.map((ownership: any) => ({
              name: ownership.legalName || `${ownership.firstName} ${ownership.lastName}`,
              value: ownership.percentage,
            }))
            setOwnership(transformedOwnership)
          }
          if (data.allSecurityClass.length > 0) {
            const transformedSecurityClass = data.allSecurityClass.map((securityClass: any) => ({
              name: securityClass.className,
              value: securityClass.percentage,
            }))
            setShareClass(transformedSecurityClass)
          }
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setDashboardLoading(false)
    }
  }

  useEffect(() => {
    getOverview()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getCountryCounts = async () => {
    try {
      const {
        data: {data},
      } = await getShareholdersDashboardCounts(companyId!)
      if (data) {
        setCountryCounts(data)
      }
    } catch (error) {
      console.log(error)
    } finally {
    }
  }

  useEffect(() => {
    getCountryCounts()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  console.log(overviewData, 'overview data')
  return (
    <div className='px-6'>
      <PageTitle
        breadcrumbs={CaptableManagementBreadCrumbs}
        description={formatMessage({id: 'Overview'})}
      >
        {formatMessage({id: 'Cap Table Management'})}
      </PageTitle>
      <div className='w-100'>
        <InfoCard2
          title={formatMessage({id: 'How to Manage Your Cap Table Efficiently?'})}
          desc={formatMessage({
            id: `${brandingConfig.brandName}’s Cap Table Management feature offers a seamless and organized approach to track your equity, project future ownership scenarios, and analyze management events.`,
          })}
          slug={brandingConfig.helpLinks.captableManagementDashboardOverview}
          className='w-100 mb-0'
        />
      </div>
      <div className='captable-wrapper pt-0'>
        {dashboardLoading ? (
          <>
            <div className='d-flex justify-content-between gap-4 my-4 flex-wrap flex-md-nowrap'>
              <CaptableManagementCardSkeleton />
              <CaptableManagementCardSkeleton />
              <CaptableManagementCardSkeleton />
              <CaptableManagementCardSkeleton />
            </div>
            <div className='d-flex justify-content-between gap-4 my-4 flex-wrap flex-md-nowrap'>
              <CaptableManagementCardSkeleton />
              <CaptableManagementCardSkeleton />
              <CaptableManagementCardSkeleton />
              <CaptableManagementCardSkeleton />
            </div>
          </>
        ) : (
          <>
            <div className='d-flex justify-content-between gap-4 my-4 flex-wrap flex-md-nowrap'>
              <CaptableManagementCard
                icon='/media/icons/captable-management/ic-user-money.svg'
                stat={`${overviewData?.totalInvestorCount}`}
                title={formatMessage({id: 'Total Investors'})}
              />
              <CaptableManagementCard
                icon='/media/icons/captable-management/ic-documents.svg'
                stat={`-`}
                // stat={`${overviewData?.totalFullyDilutedShares}`}
                title={formatMessage({id: 'Fully Diluted Shares'})}
              />
              <CaptableManagementCard
                icon='/media/icons/captable-management/ic-currency.svg'
                stat={`${overviewData?.totalMoneyRaised}`}
                title={formatMessage({id: 'Total Money Raised (US$)'})}
              />
              <CaptableManagementCard
                icon='/media/icons/captable-management/ic-chart-line.svg'
                stat={`${overviewData?.currentValuation}`}
                title={formatMessage({id: 'Current Valuation (US$)'})}
              />
            </div>
            <div className='d-flex justify-content-between gap-4 my-4 flex-wrap flex-md-nowrap'>
              <CaptableManagementCard
                icon='/media/icons/captable-management/ic-money.svg'
                stat={`${overviewData?.authorizedCaptable || 0}`}
                title={formatMessage({id: 'Authorized Capital'})}
                isAuthorized={true}
                getOverview={getOverview}
              />
              <CaptableManagementCard
                icon='/media/icons/captable-management/ic-doc-certification.svg'
                stat={`${overviewData?.authorizedShares || 0}`}
                title={formatMessage({id: 'Authorized Shares'})}
                isAuthorized={true}
                getOverview={getOverview}
              />
              <CaptableManagementCard
                icon='/media/icons/captable-management/ic-user-certification.svg'
                stat={`${overviewData?.promotersSharePercentage}`}
                title={formatMessage({id: 'Promoters Holding'})}
              />
              <CaptableManagementCard
                icon='/media/icons/captable-management/ic-user-multiple.svg'
                stat={`${overviewData?.totalShareholders}`}
                title={formatMessage({id: 'Total Shareholders'})}
              />
            </div>
          </>
        )}
      </div>
      <div className='d-flex justify-content-between gap-4 my-4 flex-wrap flex-md-nowrap'>
        {dashboardLoading ? (
          <>
            <CaptableManagementChartSkeleton />
            <CaptableManagementChartSkeleton />
            <CaptableManagementChartSkeleton />
            <CaptableManagementChartSkeleton />
          </>
        ) : (
          <>
            <CaptableManagementChart data={investors} colors={colors} title='Top 5 Investors' />
            <CaptableManagementChart
              data={shareClass}
              colors={colors}
              title='Share Class Overview'
            />
            <CaptableManagementChart
              data={promoters}
              colors={colors}
              title='Promoters & Founders'
            />
            <CaptableManagementChart
              data={ownership}
              colors={colors}
              title='Top 5 Ownership (Entity)'
            />
          </>
        )}
      </div>
      <div className='d-flex justify-content-between gap-4 my-4 flex-wrap flex-md-nowrap'>
        <div className='d-flex flex-md-row flex-column w-100 gap-4 justify-content-between'>
          {dashboardLoading ? (
            <>
              <CaptableManagementListSkeleton />
              <CaptableManagementListSkeleton />
            </>
          ) : (
            overviewData && (
              <>
                <CaptableManagementList
                  title='Top #5 Investors'
                  data={overviewData.top5Investors}
                />
                <CaptableManagementList
                  title='Top #5 Promoters'
                  data={overviewData.top5Promoters}
                />
              </>
            )
          )}
        </div>
        <div className='d-flex w-100'>
          {dashboardLoading ? (
            <CaptableManagementQuickActionsSkeleton />
          ) : (
            <CaptableManagementQuickActions title='Quick Actions' />
          )}
        </div>
      </div>
      <div className='d-flex justify-content-between gap-4 my-4 flex-wrap flex-md-nowrap'>
        <div className='d-flex flex-md-row flex-column w-100 gap-4 justify-content-between'>
          {dashboardLoading ? (
            <>
              <CaptableManagementChartSkeleton />
              <CaptableManagementChartSkeleton />
            </>
          ) : (
            <>
              <CaptableManagementChart
                data={shares_usage}
                colors={colors}
                title='Authorized shares usage'
              />
              <CaptableManagementChart
                data={diluted_ownership}
                colors={colors}
                title='Fully Diluted Ownership'
              />
            </>
          )}
        </div>
        <div className='d-flex w-100'>
          {dashboardLoading ? (
            <CaptableManagementMapSkeleton />
          ) : (
            <CaptableManagementMap title='Stakeholder By Country' countryCounts={countryCounts} />
          )}
        </div>
      </div>
      <div className='d-flex justify-content-between gap-4 my-4 flex-wrap flex-md-nowrap'>
        <div className='d-flex flex-column flex-md-row w-100 w-md-100 gap-4 justify-content-between'>
          {dashboardLoading ? (
            <CaptableManagementGraphSkeleton />
          ) : (
            <CaptableManagementGraph
              title='Journey'
              valuationGraph={overviewData?.valuationGraph}
              sharePriceGraph={overviewData?.sharepriceGraph}
            />
          )}
          {dashboardLoading ? (
            <CaptableManagementRoundSkeleton />
          ) : (
            <CaptableManagementRound
              title='Overview of Funding Rounds'
              securityClasses={overviewData?.allSecurityClasses}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Overview
